import { createGlobalStyle } from 'styled-components';
import OatmealRegularWoff from '../assets/fonts/OatmealPro2/OatmealPro2-Regular.woff';
import OatmealRegularWoff2 from '../assets/fonts/OatmealPro2/OatmealPro2-Regular.woff2';
import OatmealBoldWoff from '../assets/fonts/OatmealPro2/OatmealPro2-Bold.woff';
import OatmealBoldWoff2 from '../assets/fonts/OatmealPro2/OatmealPro2-Bold.woff2';
import PoppinsSemiBold from '../assets/fonts/Poppins/Poppins-SemiBold.ttf';

const StyleSetup = createGlobalStyle`
  @font-face {
    font-family: 'Oatmeal Pro 2 Regular';
    src: url(${OatmealRegularWoff2}) format('woff2'),
        url(${OatmealRegularWoff}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Oatmeal Pro 2 Bold';
    src: url(${OatmealBoldWoff2}) format('woff2'),
        url(${OatmealBoldWoff}) format('woff');
    font-weight: bold;
  }
  @font-face {
    font-family: 'Poppins Semi Bold';
    src: url(${PoppinsSemiBold}) format('truetype');
    font-weight: normal;
  }
  * {
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  html {
    font-size: 62.5%;
  }
  body {
    font-family: ${props => props.fontFamily || "'Hind', sans-serif"};
    font-size: 1.4rem;
    &.setHidden {
      overflow: hidden;
    }
  }
  [class^="_hj"] {
    white-space: normal !important;
  }
  div {
    white-space: nowrap;
    user-select: none;
  }
  ._hj-widget-container{
    span, div{
      white-space: normal !important;
    }
  }
  button {
    margin: 0;
    padding: 0;
    border: none;
    font: inherit;
    color: inherit;
    background: none;
  }
  *:focus {
    outline: none;
  }
  button::-moz-focus-inner {
    padding: 0;
    border: none;
  }
  ol, ul {
    list-style: none;
  }
  input, textarea {
    font-size: 16px;
    -webkit-appearance: none;
  }
  select, option {
    box-shadow: none;
    &:disabled {
      -webkit-appearance: none;
    }
  }
`;

export default StyleSetup;
